<template>
  <div class="mb-3 col-12 col-md-6 col-lg-4 px-md-2">
    <div class="inCart" v-if="itemsInCart">
      <div class="row m-0">
        <div class="col-auto py-2 text-center">
          {{itemsInCart}}
        </div>
      </div>
    </div>
    <div class="thumbnail card d-none d-md-flex" :class="{ 'product-disabled': item.soldOut, 'in_cart': itemsInCart }" @click="goToProduct">
      <div class="img-event intrinsic square-img">
        <img :src="item.thumbnail_url" alt="" class="thumbnail-image card-img-top intrinsic-item p-0" v-if="item.thumbnail_url">
        <img src="../../image/placeholder-square.png" alt="" class="thumbnail-image card-img-top intrinsic-item p-0" v-else>
      </div>
      <div class="card-body">
        <div class="row mx-0 h-100">
          <div class="col-12 p-0">
            <router-link :to="'/product/' + item.id" tag="h6" class="card-title">
              <a>
                {{ item.title }}
              </a>
            </router-link>
            <!-- <h6 class="card-subtitle mb-2 remain">{{ item.quantity }} left in stock</h6> -->
            <p class="card-text truncate">{{ item.description | shortDescription}}</p>
          </div>
          <div class="col-12 p-0 align-self-end mt-4">
            <div class="row" v-if="item.price">
              <div class="col-6 lead mb-1">R {{ item.price }}</div>
              <!-- <div class="col-6 p-0 mb-2">
                <div class="row m-0 justify-content-center align-items-center">
                  <div class="col text-right p-0" @click.stop="decrementValue">
                    <ios-remove-circle-outline-icon  />
                  </div>
                  <div class="col-4 px-1 text-center mb-2">
                    {{item_quantity}}
                  </div>
                  <div class="col text-left p-0" @click.stop="incrementValue">
                    <ios-add-circle-outline-icon  />
                  </div>
                </div>
              </div> -->
              <!-- <div class="col-12">
                <button class="btn btn-outline w-100" :disabled="item.quantity === 0 || item.soldOut" @click.stop="addItem" ref="addToCart">
                  <span v-if="addingStatus == 'adding'">Adding...</span>
                  <span v-else-if="addingStatus == 'added'" class="hoods_color">Added</span>
                  <span v-else-if="item.soldOut">Sold Out</span>
                  <span v-else>Add to cart</span>
                </button>
              </div> -->
              <div class="col-12">
                <button class="btn btn-outline w-100" >
                  <span>View</span>
                </button>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-12 lead mb-1">Contact us</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card d-md-none" :class="{ 'product-disabled': item.soldOut, 'in_cart': itemsInCart }" @click="goToProduct">
      <div class="row m-0">
        <div class="col-4 p-0">
          <img :src="item.thumbnail_url" alt="" class="img-fluid" v-if="item.thumbnail_url">
          <img src="../../image/placeholder-square.png" alt="" class="img-fluid" v-else>
        </div>
        <div class="col p-2">
          <div class="row m-0 h-100">
            <div class="col-12 p-0 bold">
              {{ item.title }}
            </div>
            <div class="col-12 p-0">
              <div class="row m-0" v-if="item.price">
                <div class="col-12 p-0 mt-2">
                  <div class="row align-items-center mb-1">
                    <div class="col-6 lead mb-1">R {{ item.price }}</div>
                    <!-- <div class="col-6 p-0">
                      <div class="row m-0 justify-content-end align-items-center">
                        <div class="col text-right p-0" @click.stop="decrementValue">
                          <ios-remove-circle-outline-icon  />
                        </div>
                        <div class="col-4 px-1 text-center mb-2">
                          {{item_quantity}}
                        </div>
                        <div class="col text-left p-0" @click.stop="incrementValue">
                          <ios-add-circle-outline-icon  />
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
                <!-- <div class="col-12 p-0 align-self-end">
                  <button class="btn btn-outline w-100" :disabled="item.quantity === 0 || item.soldOut" @click.stop="addItem" ref="addToCart">
                    <span v-if="addingStatus == 'adding'">Adding...</span>
                    <span v-else-if="addingStatus == 'added'" class="hoods_color">Added</span>
                    <span v-else-if="item.soldOut">Sold Out</span>
                    <span v-else>Add to cart</span>
                  </button>
                </div> -->
                <div class="col-12 p-0 align-self-end">
                  <button class="btn btn-outline w-100">
                    <span>View</span>
                  </button>
                </div>
              </div>
              <div class="row m-0" v-else>
                <div class="col-12 p-0 mt-2">
                  <div class="row align-items-center mb-1">
                    <div class="col-12 lead mb-1">Contact us</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['item', 'displayList'],
  data () {
    return {
      addingStatus: 'done',
      item_quantity: 1
    }
  },
  computed: {
    ...mapGetters([
      'cartItemList'
    ]),
    itemDetails () {
      return { item_id: this.item.id, item_name: this.item.title, item_category: this.item.category || 'uncategorized', price: Number(this.item.price) }
    },
    itemsInCart () {
      const record = this.cartItemList.find(element => element.id === this.item.id)
      if (record) {
        return record.quantity
      } else {
        return null
      }
    }
  },
  methods: {
    ...mapActions(['updateCart']),
    addItem () {
      this.addingStatus = 'adding'
      const order = {
        item: Object.assign({}, this.item),
        quantity: this.item_quantity,
        isAdd: true
      }
      this.updateCart(order)
      this.$analytics.logEvent('add_to_cart', { currency: 'ZAR', value: this.item.price * this.item_quantity, items: [{ ...this.itemDetails, quantity: this.item_quantity }] })
      this.addingStatus = 'added'
      setTimeout(() => {
        this.addingStatus = 'done'
        this.item_quantity = 1
        this.$nextTick(() => {
          if (typeof this.$refs.addToCart !== 'undefined') {
            this.$refs.addToCart.blur()
          }
        })
      }, 2000)
    },
    incrementValue () {
      this.item_quantity++
    },
    decrementValue () {
      if (this.item_quantity > 0) {
        this.item_quantity--
      }
    },
    goToProduct () {
      this.$router.push({ path: `/${this.$route.params.storeId}/product/${this.item.id}` })
    }
  },
  filters: {
    shortDescription (value) {
      if (value && value.length > 150) {
        return value.substring(0, 150) + '...'
      } else {
        return value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
div.card {
  height: 100%;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
  background-color: var(--light-color);
  border: none;
}
.dark-mode div.card {
  background-color: var(--dark-color-off);
}
.card:hover {
  cursor: pointer;
  -webkit-box-shadow: 0 0 8px 1px var(--dark-color-03);
  box-shadow: 0 0 8px 1px var(--dark-color-03);
}
.card-img, .card-img-top {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.card-text {
  font-size: 0.875rem;
  line-height: 1.2;
}
.truncate {
  word-wrap: break-word;
  overflow-y: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 3;
}
.truncate_small {
  word-wrap: break-word;
  overflow-y: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 1;
}
.inCart {
  position: absolute;
  font-size: 0.7rem;
  top: 0;
  left: 15px;
  z-index: 2;
  background-color: var(--hoods-color);
  color: var(--light-color);
}
.dark-mode .inCart {
  background-color: var(--hoods-color);
  color: var(--light-color);
}
.remain {
  color: #d17581;
}
.product-disabled {
  opacity: 0.4;
}
.intrinsic {
  padding-top: 0;
  position: relative;
  height: 20vh;
  width: 100%;
  background-color: var(--dark-color-01);
}
.square-img {
  width: 100%;
  padding-top: 100%; /* 1:1 Aspect Ratio */
  position: relative;
  background-color: var(--dark-color-01);
}
.dark-mode .intrinsic {
  background-color: var(--light-color-04);
}
.intrinsic-item {
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.square-img .intrinsic-item{
  position: absolute;
  top: 0;
}
.list-group-item {
  float: none;
  width: 100%;
  background-color: #fff;
  margin-bottom: 30px;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0 1rem;
  border: 0;
  .thumbnail {
    display: inline-block;
    width: 100%;
  }
  .img-event {
    width: 20%;
    float: left;
    padding: 0 !important;
    margin: 0;
    height: auto;
  }

  .thumbnail-image {
    position: static;
  }

  .card-body {
    float: left;
    width: 80%;
    margin: 0;
  }

  @media (max-width: 767.98px) {
    .img-event {
      width: 30%;
      float: left;
      padding: 0 !important;
      margin: 0;
    }

    .card-body {
      float: left;
      width: 70%;
      margin: 0;
    }
  }
}

.counter {
  -ms-flex: 0 0 40px;
  -webkit-box-flex: 0;
  flex: 0 0 40px;
  max-width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid var(--dark-color);
}
.dark-mode .counter {
  border: 1px solid var(--light-color);
}
@media (min-width: 768px) {
  .inCart {
    right: 0.5rem;
    left: auto;
  }
  .in_cart {
    border: 2px solid var(--hoods-color) !important;
  }
  .dark-mode .in_cart {
    border: 2px solid var(--hoods-color) !important;
  }
}
</style>
